import * as THREE from 'three'
import { Component } from '@ecs/Component'
import { Camera } from '@components/Graphics/Camera'
import { TransformData } from './Transform'
import type { SpecificController } from './SpecificController'
import { OverlayInterface, setElementVisibility } from './UI/OverlayInterface'


export class PlayerController extends Component {
    speed = new THREE.Vector3(0, 0, 0)
    cameraRef?: WeakRef<Camera>
    specificControllers: SpecificController[] = []

    overlayInterface!: OverlayInterface
    get currentController(): SpecificController | undefined {
        if (this.specificControllers.length > 0) {
            return this.specificControllers[this.specificControllers.length - 1]
        }
    }
    reloadOverlay() {
        //add controller to have a form like "Acceuil > P5js > Ball Simulator" with each clickable to go back to the previous controller
        const stackViewer = this.overlayInterface.element.querySelector('#StackViewer') as HTMLDivElement
        let html = ''
        for (let i = 0; i < this.specificControllers.length; i++) {
            const controller = this.specificControllers[i]
            html += `<span style="cursor: pointer; text-decoration: underline;" data-index="${i}">${controller.name}</span>`
            if (i < this.specificControllers.length - 1) html += ' > ';
        }
        stackViewer.innerHTML = html;
        for (let i = 0; i < this.specificControllers.length; i++) {
            // if clicked, destroy all controllers after this one
            const spanElem = (stackViewer.querySelector(`span[data-index="${i}"]`) as HTMLSpanElement)
            spanElem.onclick = (() => {
                console.log('clicked on', i)
                for (let j = this.specificControllers.length - 1; j > i; j--) {
                    this.specificControllers[j].gameObject.removeComponent(this.specificControllers[j])
                    console.log('removed controller via stack viewer')
                }
            })
        }
    }
    addSubController(controller: SpecificController) {
        if (this.currentController !== undefined) this.currentController.interupted = true
        this.specificControllers.push(controller)
        this.reloadOverlay()
    }
    //remove controller and other added after him
    removeController(controller: SpecificController) {
        const index = this.specificControllers.indexOf(controller)
        if (index >= 0) {
            this.specificControllers.splice(index)
        }
        this.reloadOverlay()
    }
    get input() { return this.gameObject.engine.input }
    set smoothFactor(value: number) {
        this.positionSmoothFactor = value
        this.rotationSmoothFactor = value
        this.scaleSmoothFactor = value
        this.cameraDistanceSmoothFactor = value
    }
    cameraDistance = 0

    cameraDistanceSmoothFactor = 0.1
    positionSmoothFactor = 0.1
    rotationSmoothFactor = 0.1
    scaleSmoothFactor = 0.1
    targetTransform!: TransformData


    setDistanceSavingCameraPosition(dist: number) {
        this.targetTransform.position.sub(this.transform.forward.clone().multiplyScalar(dist - this.cameraDistance))
        this.cameraDistance = dist
    }

    start() {
        const camera = this.gameObject.getComponent(Camera)
        this.cameraRef = camera ? new WeakRef(camera) : undefined
        this.targetTransform = new TransformData().copy(this.transform.transformData)
        //add overlay with tect un up left corner
        this.overlayInterface = this.gameObject.addComponent(OverlayInterface, {
            innerHTML: `
            <div style="position: absolute; top: 20px; left: 20px;height:50px; color: white; font-family: Arial, sans-serif; font-size: 25px; background: rgba(0, 0, 0, 0.5); padding: 10px 20px; border-radius: 10px; pointer-events: auto;">
            <span id="StackViewer">Aucun controleur actif</span>
            </div>
                `})
    }
    update(dt: number) {

        if (this.currentController === undefined) {
            // do nothing 
        } else {
            this.currentController.updateActions(dt)
            if (this.currentController) this.currentController.interupted = false
            this.synchronizeTarget()
        }
        if (this.currentController && this.specificControllers.length <= 1) {
            setElementVisibility(this.currentController.exitBtnOverlay.element, false)
        }
    }
    synchronizeTarget() {
        if (this.currentController) {
            this.targetTransform.copy(this.currentController.targetTransform)
            this.cameraDistance = this.currentController.cameraDistance
        }
    }
    render(_dt: number): void {

    }
    updateMovementSmoothly() {
        this.synchronizeTarget()
        this.transform.transformData.setPosition(this.transform.position.clone().sub(this.transform.forward.clone().multiplyScalar(this.cameraDistance))).LerpB(this.targetTransform, this.positionSmoothFactor, this.rotationSmoothFactor, this.scaleSmoothFactor).position.add(this.transform.forward.clone().multiplyScalar(this.cameraDistance))
        this.transform.markDirty()
        this.gameObject.onMoveUpdate()
    }
    onAfterMove(): void {
        this.updateMovementSmoothly()
    }
    onDestroy(): void {
        //console.log('player destroyed')
        this.gameObject.removeComponent(this.overlayInterface)
    }
}